module.exports = __webpack_public_path__ + "img/content_3_FactoryDirectSupply.7c1f1771.png";